import React from 'react';
import { useDesign } from '../contexts/DesignContext';
import StaticPageLayout from '../components/Layout/StaticPageLayout';

const Contact = () => {
  const { designConfig } = useDesign();

  const email = designConfig.contact_email || '[TODO: add support email in Admin Settings]';
  const phone = designConfig.contact_phone || '[TODO: add support phone in Admin Settings]';

  const addressParts = [
    designConfig.invoice_company_address,
    designConfig.invoice_company_city,
    designConfig.invoice_company_state,
    designConfig.invoice_company_zip,
    designConfig.invoice_company_country
  ].filter(Boolean);
  const address = addressParts.length > 0
    ? addressParts.join(', ')
    : '[TODO: add business address in Admin Settings]';

  return (
    <StaticPageLayout title="Contact Us">
      <p>
        We'd love to hear from you. Reach out with questions about an order, a product, or anything else -
        we usually respond within 24-48 hours.
      </p>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Email</h2>
        <p>{email}</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Phone</h2>
        <p>{phone}</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Address</h2>
        <p>{address}</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Instagram</h2>
        <p>
          <a
            href="https://www.instagram.com/viverrafancy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            @viverrafancy
          </a>
        </p>
      </div>
    </StaticPageLayout>
  );
};

export default Contact;
